<template>
	<!-- begin sidebar nav -->
	<div
		class="menu"
		v-loading="menus.length == 0"
		element-loading-text="正在获取菜单列表"
		element-loading-spinner="el-icon-loading"
	>
		<div class="menu-search mb-n3" v-if="appOptions.appSidebarSearch">
			<input type="text" v-on:keyup="handleSidebarFilter" class="form-control" placeholder="Sidebar menu filter..." maxlength="20" />
		</div>
		<!-- <div class="menu-header">导航菜单</div> -->
		<template v-for="menu in menus">
			<sidebar-nav-list
				ref="sidebarNavList"
				v-bind:menu="menu"
				v-bind:scrollTop="scrollTop"
				v-bind:key="menu.path"
				v-bind:status="menu.status"
				v-on:collapse-other="handleCollapseOther(menu)"
				v-on:show-float-submenu="handleShowFloatSubmenu"
				v-on:hide-float-submenu="handleHideFloatSubmenu"
			></sidebar-nav-list>
		</template>

		<!-- BEGIN minify-button -->
		<div class="menu-item d-flex">
			<a href="javascript:;" class="souf app-sidebar-minify-btn ms-auto" v-on:click="handleSidebarMinify()"><i class="fa fa-angle-double-left"></i></a>
		</div>
		<!-- END minify-button -->
	</div>
	<!-- end sidebar nav -->
</template>

<style scoped>
.app-sidebar-minify-btn:hover {
	background: #edd5b2 !important;
}

.app-sidebar-minify-btn {
	background-color: #edd5b2;
}

.menu {
	height: 90vh;
	overflow-y: scroll;
}
.menu::-webkit-scrollbar {
	display: none;
}
</style>

<script>
import SidebarMenu from './SidebarMenu.vue';
import SidebarNavList from './SidebarNavList.vue';
import AppOptions from '../../config/AppOptions.vue';
import { getUserSingle } from '@/request/api/mange/mange.js';

export default {
	name: 'SidebarNav',
	props: ['scrollTop'],
	components: {
		SidebarNavList
	},
	data() {
		return {
			menus: [],
			appOptions: AppOptions
		};
	},
	beforeMount() {
		// console.log(this.$route.name)
	},

	mounted() {
		let userinfo = JSON.parse(localStorage.getItem('userss'));
		if (userinfo) {
			let autohsbtnlist = [];
			userinfo.UserMenuList.forEach(item => {
				item.icon = item.icon ?? '';
				if (item.children.length == 0) {
					delete item.children;
				} else {
					item.children.forEach(ite => {
						if (ite.children.length > 0) {
							ite.children.forEach(it => {
								autohsbtnlist.push(it);
							});
							delete ite.children;
						} else {
							delete ite.children;
						}
						ite.icon = ite.icon ?? '';
					});
				}
			});
			window.sessionStorage.setItem('allbtnlist', JSON.stringify(autohsbtnlist));
			this.menus = userinfo.UserMenuList;

			// console.log('这里获取到了登录信息')
		} else {
			if (
				this.$route.name != '登录' ||
				this.$route.name != '注册' ||
				this.$route.name != '忘记密码' ||
				this.$route.name !== '云首页' ||
				this.$route.name !== '测试' ||
				this.$route.name !== '云课程' ||
				this.$route.name !== '资源库'
			) {
				setTimeout(() => {
					this.getlogins();
				});
			}
		}
	},
	beforeUpdate() {},

	methods: {
		getlogins() {
			if (localStorage.getItem('uiguid') && localStorage.getItem('token')) {
				// console.log("如果cookie里面没有就是从自己拿")
				getUserSingle(localStorage.getItem('uiguid')).then(res => {
					if (res.data.code == -2) {
						localStorage.clear();
						// this.$cookie.clear();
						return;
					}

					if (res.data.code == -1) {
						// console.log("无权限")
						// this.$router.push("/user/logins")
						return;
					}

					let autohsbtnlist = [];
					if (res.data.data.UserMenuList && res.data.data.UserMenuList.length) {
						res.data.data.UserMenuList.forEach(item => {
							item.icon = item.icon ?? '';
							if (item.children.length == 0) {
								delete item.children;
							} else {
								item.children.forEach(ite => {
									if (ite.children.length > 0) {
										ite.children.forEach(it => {
											autohsbtnlist.push(it);
										});
										delete ite.children;
									} else {
										delete ite.children;
									}
									ite.icon = ite.icon ?? '';
								});
							}
						});
						this.menus = res.data.data.UserMenuList;
					}

					// console.log(autohsbtnlist,'权限')
					window.sessionStorage.setItem('allbtnlist', JSON.stringify(autohsbtnlist));
					// window.sessionStorage.setItem("allbtnlist",JSON.stringify(autohsbtnlist));
					this.$cookie.set('lookinmune', JSON.stringify(res.data.data.LockUserMenuList));
				});
			} else {
			}
		},
		handleShowFloatSubmenu: function(menu, offset) {
			this.$emit('show-float-submenu', menu, offset);
		},
		handleHideFloatSubmenu: function() {
			this.$emit('hide-float-submenu');
		},
		handleCollapseOther: function(menu) {
			for (var i = 0; i < this.menus.length; i++) {
				this.$refs.sidebarNavList[i].collapse(menu);
			}
		},
		handleSidebarMinify: function() {
			this.appOptions.appSidebarMinified = !this.appOptions.appSidebarMinified;
		},
		handleSidebarFilter: function(e) {
			var value = e.target.value;
			value = value.toLowerCase();

			if (value) {
				for (var x = 0; x < this.menus.length; x++) {
					var title = this.menus[x].title.toLowerCase();
					var children = this.menus[x].children;

					if (title.search(value) > -1) {
						this.$refs.sidebarNavList[x].show();

						if (children) {
							this.$refs.sidebarNavList[x].searchExpand();
						}
					} else {
						if (children) {
							var hasActive = false;
							for (var y = 0; y < children.length; y++) {
								var title2 = children[y].title.toLowerCase();

								if (title2.search(value) > -1) {
									hasActive = true;
									this.$refs.sidebarNavList[x].$refs.sidebarNavList[y].show();
									this.$refs.sidebarNavList[x].searchExpand();
								} else {
									if (hasActive) {
										this.$refs.sidebarNavList[x].searchExpand();
									} else {
										this.$refs.sidebarNavList[x].hide();
									}
									this.$refs.sidebarNavList[x].$refs.sidebarNavList[y].hide();
								}
							}
						} else {
							this.$refs.sidebarNavList[x].hide();
						}
					}
				}
			} else {
				for (var a = 0; a < this.menus.length; a++) {
					this.$refs.sidebarNavList[a].show();

					var submenu = this.menus[a].children;
					if (submenu) {
						for (var b = 0; b < submenu.length; b++) {
							this.$refs.sidebarNavList[a].$refs.sidebarNavList[b].show();
						}
					}
				}
			}
			console.log('------');
		}
	}
};
</script>
